import ctl from '@netlify/classnames-template-literals';

export const containerStyle = ctl(`
  flex 
  w-full 
  h-full 
  p-5 
  space-x-4 
  bg-anti-flash-white
`);

export const iconContainerStyle = ctl(`
  w-[100px] 
  h-[100px] 
  rounded-sm
  text-[60px] 
  text-anti-flash-white 
  flex items-end 
  justify-center 
  bg-silver-sand
`);
